// LeaveDistribution.jsx
import { useMemo } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip } from "chart.js";
import "../../../style/leavetabcommon.css";

ChartJS.register(ArcElement, Tooltip);

export default function LeaveDistribution({ leaveList = [] }) {

  const chartConfig = useMemo(() => {
    // 🔹 Find required leave types
    const generalLeave = leaveList.find(l =>
      l.type?.includes("General Leave")
    );

    const privilegeLeave = leaveList.find(l =>
      l.type?.includes("Privilege Leave")
    );

    const generalTaken = generalLeave?.takenLeave || 0;
    const privilegeTaken = privilegeLeave?.takenLeave || 0;

    const totalEntitled =
      (generalLeave?.leaveBalance || 0) +
      (privilegeLeave?.leaveBalance || 0);

    const totalTaken = generalTaken + privilegeTaken;
    const available = Math.max(totalEntitled - totalTaken, 0);

    return {
      data: {
        labels: [
          "General Leave",
          "Privilege Leave",
          "Available"
        ],
        datasets: [
          {
            data: [
              generalTaken,
              privilegeTaken,
              available
            ],
            backgroundColor: [
              "#3b82f6", // General - blue
              "#ef4444", // Privilege - red
              "#e5e7eb"  // Available - grey
            ],
            borderWidth: 1,
            borderColor: "#fff"
          }
        ]
      },
      meta: {
        generalTaken,
        privilegeTaken,
        available,
        totalEntitled
      }
    };
  }, [leaveList]);

  return (
    <div className="card leave-distribution">
  <div className="d-flex align-items-start gap-3 mb-3">

  {/* Icon */}
  <div className="icon-box bg-info-light">
    <i className="fas fa-chart-pie text-info"></i>
  </div>

  {/* Title + Subtitle */}
  <div>
    <h5 className="mb-1 fw-semibold">Leave Distribution</h5>
    <p className="text-muted small mb-0">
      Leave usage breakdown overview
    </p>
  </div>

</div>
    <div className="distribution-body">
      
      {/* LEFT SIDE – PIE */}
      <div className="chart-wrapper">
        <Pie
          data={chartConfig.data}
          options={{
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: ctx => {
                    const value = ctx.raw;
                    const percent = chartConfig.meta.totalEntitled
                      ? ((value / chartConfig.meta.totalEntitled) * 100).toFixed(0)
                      : 0;
                    return `${ctx.label}: ${percent}%`;
                  }
                }
              }
            }
          }}
        />
      </div>

      {/* RIGHT SIDE – DETAILS */}
      <div className="leave-details">
        <ul className="leave-legend">
          <li className="blue">
            <span></span>
            General Leave: {chartConfig.meta.generalTaken} days
          </li>

          <li className="red">
            <span></span>
            Privilege Leave: {chartConfig.meta.privilegeTaken} days
          </li>

          <li className="grey">
            <span></span>
            Available: {chartConfig.meta.available} days
          </li>
        </ul>
      </div>
    </div>
  </div>
  );
}
